module.exports = __webpack_public_path__ + "img/active2020.c2b8a46b.png";